import { createAction, props } from '@ngrx/store';
import { IGlimpseReport } from 'src/app/modules/customer-shared/models/IGlimpseReport';
import { IAreaDate } from 'src/app/modules/report-components/models/IAreaDate';
import { PosCategorySop } from "src/app/modules/customer-shared/models/PosCategorySop";
import { IAuditSales } from "../../modules/shared/models/IAuditSales";

//
// COMMANDS [verbNoun]
//

export const loadReport = createAction(
  `[Report Page] Load Report`,
  props<{
    hydrateWith: IGlimpseReport;
    isPreview: boolean;
  }>(),
);

export const loadAreaDates = createAction(`[Report Page] Load Area Dates`, props<{ areaId: number }>());

export const loadAreaMonths = createAction(`[Report Page] Load Area Months`, props<{ areaId: number }>());

export const changeSOP = createAction(`[Report Page] Change SOP`, props<{ pre: number; post: number }>());

export const resetSOP = createAction(`[Report Page] Reset SOP`);

export const useBarFilter = createAction(`[Report Page] Use Bar Filter`, props<{ sectionId: number }>());

export const clearBarFilter = createAction(`[Report Page] Clear Bar Filter`);

//
// EVENTS [nounVerb]
//

export const reportLoadError = createAction(`[Report API] Report Load Error`, props<{ error: string }>());

export const reportLoadSuccess = createAction(`[Report API] Report Load Success`, props<{ report: IGlimpseReport }>());

//
// DOCUMENTS [setNoun]
//

export const setCurrentReport = createAction(
  `[Report Page] Set Current Report`,
  props<{
    report: IGlimpseReport;
    cache: boolean;
  }>(),
);
export const setAreaDates = createAction(
  `[Report Page] Set Area Dates`,
  props<{
    dates: IAreaDate[];
    areaId: number;
  }>(),
);
export const setAreaMonths = createAction(
  `[Report Page] Set Area Months`,
  props<{
    months: IAreaDate[];
    areaId: number;
  }>(),
);

export const loadPosCategorySop = createAction(
  `[Report Page] Load Pos Category Sop`,
  props<{
    customerId: number;
    locationId: number;
  }>(),
);

export const loadPosCategorySopSuccess = createAction(
  `[Report Page] Load Pos Category Sop Success`,
  props<{
    sop: PosCategorySop[];
  }>(),
);
export const loadPosCategorySopFail = createAction(`[Report Page] Load Pos Category Sop Error`, props<{ error: Error }>());

export const updatePosCategorySop = createAction(
  `[Report Page] Update Pos Category Sop`,
  props<{
    customerId: number;
    locationId: number;
    sop: PosCategorySop[];
  }>(),
);
export const updatePosCategorySopSuccess = createAction(`[Report Page] Update Pos Category Sop Success`);
export const updatePosCategorySopFail = createAction(`[Report Page] Update Pos Category Sop Fail`, props<{ error: Error }>());

export const loadAuditSales = createAction(`[Report Page] Load Audit Sales`, props<{ areaId: number, periodId: string }>());
export const loadAuditSalesSuccess = createAction(`[Report Page] Load Audit Sales Success`, props<{ sales: IAuditSales; }>());
export const loadAuditSalesFail = createAction(`[Report Page] Load Audit Sales Fail`, props<Error>());
